module.exports = __webpack_public_path__ + "img/black01_128.8d2d6917.png";